// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_pm-0";
export var animationContainer = "_pm-1";
export var itemPrice = "_pm-a";
export var itemizedContent = "_pm-9";
export var itemizedHeader = "_pm-7";
export var itemizedRow = "_pm-8";
export var itemizedSection = "_pm-6";
export var modalContent = "_pm-2";
export var orderName = "_pm-3";
export var refundOption = "_pm-4";
export var refundOptionsContainer = "_pm-5";
export var shippingLabel = "_pm-b";
export var totalRow = "_pm-c";